import css from './stat.scss?inline';
import globalStyles from '../../index.scss?inline';	
import { ArgSpecDictionary, TypedVars } from "../component-utils";

const DEBUG_VERBOSE: boolean  = false;
const CLASS_NAME: string = 'HHDSStat';
const TAG_NAME: string = 'hhds-stat';
export const HHDSStatTagName: string = "hhds-stat";

// ////////////////////////////////////////////////////////////////////

export class HHDSStat extends HTMLElement {

  private vars: TypedVars = new TypedVars(this);
	private shadow: ShadowRoot;	

	constructor() {
		super();
		DEBUG_VERBOSE && console.log(CLASS_NAME, 'constructed');

		this.shadow = this.attachShadow({ mode: 'open' });
		if (!this.shadow) {
			return;
		}

	}

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Lifecycle Methods
	// https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks

	// Invoked each time the custom element is appended into a document-connected element.
  connectedCallback() {

		this.parseAttributes();

		this.render();

		DEBUG_VERBOSE && console.log(`[${TAG_NAME}] Initialised`);
	}

  parseAttributes() {
    this.vars.parse(this, ArgSpecs);
	}

	render() {
		const statistic = this.vars.get<string>("statistic"),
			description = this.vars.get<string>("description");

		this.shadow.innerHTML = `
			<style>${globalStyles}</style>
			<style>${css}</style>
			<div class="hhds-stat">
				${statistic ? `<p class="hhds-stat__statistic stat">${statistic}</p>` : ``}
				${description ? `<p class="hhds-stat__description stat-caption">${description}</p>` : ``}
			</div>
		`;
	}

	// Invoked each time the custom element is disconnected from the document's DOM.
	disconnectedCallback() {}

	// Invoked each time the custom element is moved to a new document.
	adoptedCallback() {}

	// Invoked each time one of the custom element's attributes is added, removed, or changed.
	attributeChangedCallback() {}

}

export const ArgSpecs: ArgSpecDictionary = {
	"statistic": {
		description: `The statistic text.`,
		defaultValue: "#1",
		type: String
	},
	"description": {
		description: `Optional description text.`,
		defaultValue: "Concentration of stem professionals",
		type: String
	},
};

